import { Skeleton } from "@/components/ui/skeleton";

export const MessagesSkeleton = () => (
  <div className="flex h-[calc(100vh-4rem)] overflow-hidden">
    {/* Sidebar */}
    <div className="w-full md:w-[380px] border-r flex flex-col">
      <div className="flex-1 px-3 pt-4 space-y-2">
        {[...Array(8)].map((_, i) => (
          <Skeleton key={i} className="h-[88px] w-full rounded-2xl" />
        ))}
      </div>
      <div className="p-4 space-y-3 border-t">
        <Skeleton className="h-10 w-full rounded-full" />
        <Skeleton className="h-11 w-full rounded-2xl" />
      </div>
    </div>
    {/* Thread area */}
    <div className="hidden md:flex flex-1 flex-col items-center justify-center gap-4">
      <Skeleton className="h-16 w-16 rounded-3xl" />
      <Skeleton className="h-5 w-48" />
      <Skeleton className="h-4 w-32" />
    </div>
  </div>
);
